import React, { useEffect, useState } from "react";
import { subscribeAppleMobileNavState, toggleAppleMobileNav } from "./appleMobileNav";

/** Same panel glyph as the desktop sidebar toggle (`SideIcon type="sidebar"`). */
function SidebarPanelIcon() {
  const stroke = 1.45;
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <rect x="4" y="5.4" width="16" height="13.2" rx="2.4" fill="none" stroke="currentColor" strokeWidth={stroke} />
      <path d="M9.2 5.4v13.2" fill="none" stroke="currentColor" strokeWidth={stroke} strokeLinecap="round" />
    </svg>
  );
}

const AppleTvMobileMenuButton = ({ className = "" }) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => subscribeAppleMobileNavState(setIsOpen), []);

  return (
    <button
      type="button"
      className={`apple-clone__mobile-menu-btn${isOpen ? " is-open" : ""}${className ? ` ${className}` : ""}`}
      onClick={toggleAppleMobileNav}
      aria-label={isOpen ? "Close menu" : "Open menu"}
      title={isOpen ? "Close menu" : "Open menu"}
      aria-expanded={isOpen}
    >
      <SidebarPanelIcon />
    </button>
  );
};

export default AppleTvMobileMenuButton;
